import { Injectable } from '@angular/core';
import { BehaviorSubject } from '../../../node_modules/rxjs';

@Injectable()
export class LoaderService {

  public isLoading = new BehaviorSubject(false);
  
  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/services/loader.service.ts